import React, {
  useState,
  useEffect,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import Alerta from "../components/Alertas";
import useObtenerCliente from "../hooks/useObtenerCliente";
import EditarCliente from "../firebase/EditarClientesDb";

import {
  auth,
} from "../firebase/firebaseConfig";

import {
  Container,
  Segment,
  Form,
  Header,
  Button,
  Icon,
} from "semantic-ui-react";

const ActualizaCliente = () => {
  const user = auth.currentUser;

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  const [cliente] =
    useObtenerCliente(id);

  // ==========================================================
  // ESTADOS
  // ==========================================================

  const [
    alerta,
    cambiarAlerta,
  ] = useState({});

  const [
    estadoAlerta,
    cambiarEstadoAlerta,
  ] = useState(false);

  const [
    rut,
    setRut,
  ] = useState("");

  const [
    nombre,
    setNombre,
  ] = useState("");

  const [
    direccion,
    setDireccion,
  ] = useState("");

  const [
    telefono,
    setTelefono,
  ] = useState("");

  const [
    correo,
    setCorreo,
  ] = useState("");

  const [
    checked,
    setChecked,
  ] = useState(false);

  const [
    nomRsf,
    setNomRsf,
  ] = useState("");

  const [
    dirRsf,
    setDirRsf,
  ] = useState("");

  const [
    telRsf,
    setTelRsf,
  ] = useState("");

  const [
    date,
    setDate,
  ] = useState("");

  const [
    isSaving,
    setIsSaving,
  ] = useState(false);

  // ==========================================================
  // VOLVER
  // ==========================================================

  const volver = () => {
    navigate(
      "/clientes"
    );
  };

  // ==========================================================
  // CARGAR CLIENTE
  // ==========================================================

  useEffect(() => {
    if (!cliente) {
      return;
    }

    setRut(
      cliente.rut || ""
    );

    setNombre(
      cliente.nombre || ""
    );

    setDireccion(
      cliente.direccion || ""
    );

    setTelefono(
      cliente.telefono || ""
    );

    setCorreo(
      cliente.correo || ""
    );

    setNomRsf(
      cliente.nomrsf || ""
    );

    setDirRsf(
      cliente.dirrsf || ""
    );

    setTelRsf(
      cliente.telrsf || ""
    );

    /*
     * Si existe información del responsable,
     * dejamos marcado automáticamente el checkbox.
     */
    const tieneResponsable =
      Boolean(
        cliente.nomrsf ||
        cliente.dirrsf ||
        cliente.telrsf
      );

    setChecked(
      tieneResponsable
    );

    if (
      cliente.fnaci
    ) {
      try {
        setDate(
          cliente.fnaci
            .toDate()
            .toISOString()
            .slice(
              0,
              10
            )
        );
      } catch (error) {
        setDate("");
      }
    } else {
      setDate("");
    }
  }, [
    cliente,
  ]);

  // ==========================================================
  // ACTUALIZAR
  // ==========================================================

  const handleSubmit =
    async (e) => {
      e.preventDefault();

      cambiarEstadoAlerta(
        false
      );

      cambiarAlerta({});

      const nombreNormalizado =
        String(
          nombre || ""
        )
          .toLocaleUpperCase()
          .trim();

      const direccionNormalizada =
        String(
          direccion || ""
        )
          .toLocaleUpperCase()
          .trim();

      const correoNormalizado =
        String(
          correo || ""
        )
          .toLocaleLowerCase()
          .trim();

      const nomRsfNormalizado =
        String(
          nomRsf || ""
        )
          .toLocaleUpperCase()
          .trim();

      const dirRsfNormalizado =
        String(
          dirRsf || ""
        )
          .toLocaleUpperCase()
          .trim();

      const telRsfNormalizado =
        String(
          telRsf || ""
        ).trim();

      const expresionRegular =
        /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;

      // ======================================================
      // VALIDACIONES
      // ======================================================

      if (!rut) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo RUT no puede estar vacío.",
        });

        return;
      }

      if (
        !nombreNormalizado
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Nombre no puede estar vacío.",
        });

        return;
      }

      if (
        !direccionNormalizada
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Dirección no puede estar vacío.",
        });

        return;
      }

      if (
        !telefono ||
        telefono === "+56"
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Teléfono no puede estar vacío.",
        });

        return;
      }

      if (
        !expresionRegular.test(
          correoNormalizado
        )
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Favor ingresar un correo válido.",
        });

        return;
      }

      if (
        checked &&
        !nomRsfNormalizado
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Nombre Responsable no puede estar vacío.",
        });

        return;
      }

      if (
        checked &&
        !dirRsfNormalizado
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Dirección Responsable no puede estar vacío.",
        });

        return;
      }

      if (
        checked &&
        !telRsfNormalizado
      ) {
        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Campo Teléfono Responsable no puede estar vacío.",
        });

        return;
      }

      // ======================================================
      // GUARDAR
      // ======================================================

      setIsSaving(
        true
      );

      try {
        await EditarCliente({
          id:
            id,

          nombre:
            nombreNormalizado,

          direccion:
            direccionNormalizada,

          telefono:
            telefono,

          fnaci:
            date
              ? new Date(
                  date
                )
              : null,

          correo:
            correoNormalizado,

          /*
           * Si se desmarca responsable financiero,
           * limpiamos los campos.
           */
          nomrsf:
            checked
              ? nomRsfNormalizado
              : "",

          dirrsf:
            checked
              ? dirRsfNormalizado
              : "",

          telrsf:
            checked
              ? telRsfNormalizado
              : "",

          userMod:
            user?.email ||
            "",

          fechaMod:
            new Date(),
        });

        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "exito",
          mensaje:
            "Cliente actualizado exitosamente.",
        });
      } catch (error) {
        console.error(
          "Error actualizando cliente:",
          error
        );

        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "No fue posible actualizar el cliente.",
        });
      } finally {
        setIsSaving(
          false
        );
      }
    };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth: 1500,
        padding:
          "24px 28px",
        background:
          "#f8fafc",
        minHeight:
          "100vh",
      }}
    >
      {/* ==================================================== */}
      {/* ENCABEZADO */}
      {/* ==================================================== */}

      <div
        style={{
          display:
            "flex",
          alignItems:
            "center",
          gap: 14,
          marginBottom:
            20,
        }}
      >
        <div
          style={{
            width:
              48,
            height:
              48,
            minWidth:
              48,
            borderRadius:
              12,
            background:
              "#e5f7f7",
            display:
              "flex",
            alignItems:
              "center",
            justifyContent:
              "center",
          }}
        >
          <Icon
            name="user edit"
            style={{
              margin:
                0,
              color:
                "#0d9da5",
              fontSize:
                21,
            }}
          />
        </div>

        <div>
          <Header
            as="h2"
            style={{
              margin:
                0,
              color:
                "#172b4d",
              fontSize:
                24,
              fontWeight:
                700,
            }}
          >
            Actualizar Paciente
          </Header>

          <div
            style={{
              color:
                "#8793a5",
              fontSize:
                13,
              marginTop:
                4,
            }}
          >
            Modifica los datos de contacto y antecedentes del paciente
          </div>
        </div>
      </div>

      {/* ==================================================== */}
      {/* TARJETA */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius:
            8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding:
            0,
          background:
            "#ffffff",
          overflow:
            "visible",
        }}
      >
        {/* CABECERA TARJETA */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display:
              "flex",
            alignItems:
              "center",
            gap:
              9,
            color:
              "#253858",
            fontWeight:
              600,
          }}
        >
          <Icon
            name="address card outline"
            style={{
              color:
                "#0d9da5",
            }}
          />

          Datos del paciente
        </div>

        <div
          style={{
            padding:
              20,
          }}
        >
          <Form
            size="small"
            onSubmit={
              handleSubmit
            }
          >
            {/* ============================================== */}
            {/* IDENTIFICACIÓN */}
            {/* ============================================== */}

            <div
              style={
                sectionTitleStyle
              }
            >
              <Icon name="id card outline" />
              Identificación
            </div>

            <Form.Group
              widths="equal"
            >
              <Form.Input
                readOnly
                fluid
                label="RUT"
                icon="address card"
                iconPosition="left"
                value={
                  rut
                }
                style={{
                  opacity:
                    0.8,
                }}
              />

              <Form.Input
                readOnly
                fluid
                label="Nombre"
                icon="user"
                iconPosition="left"
                value={
                  nombre
                }
                style={{
                  opacity:
                    0.8,
                }}
              />

              <Form.Input
                fluid
                label="Fecha de nacimiento"
                icon="calendar alternate outline"
                iconPosition="left"
                type="date"
                value={
                  date
                }
                onChange={(e) =>
                  setDate(
                    e.target.value
                  )
                }
              />
            </Form.Group>

            {/* ============================================== */}
            {/* CONTACTO */}
            {/* ============================================== */}

            <div
              style={
                sectionTitleStyle
              }
            >
              <Icon name="phone" />
              Contacto
            </div>

            <Form.Group
              widths="equal"
            >
              <Form.Input
                fluid
                label="Dirección"
                icon="map marker alternate"
                iconPosition="left"
                placeholder="Dirección"
                value={
                  direccion
                }
                onChange={(e) =>
                  setDireccion(
                    e.target.value
                  )
                }
              />

              <Form.Input
                fluid
                label="Teléfono"
                icon="phone"
                iconPosition="left"
                placeholder="+56912345678"
                value={
                  telefono
                }
                onChange={(e) => {
                  let value =
                    e.target.value.replace(
                      /\D/g,
                      ""
                    );

                  if (
                    value.startsWith(
                      "56"
                    )
                  ) {
                    value =
                      value.slice(
                        2
                      );
                  }

                  setTelefono(
                    "+56" +
                      value
                  );
                }}
              />

              <Form.Input
                fluid
                label="Correo"
                icon="mail"
                iconPosition="left"
                placeholder="correo@ejemplo.cl"
                value={
                  correo
                }
                onChange={(e) =>
                  setCorreo(
                    e.target.value
                  )
                }
              />
            </Form.Group>

            {/* ============================================== */}
            {/* RESPONSABLE FINANCIERO */}
            {/* ============================================== */}

            <div
              style={{
                marginTop:
                  18,
                padding:
                  "14px 16px",
                background:
                  "#f8fafc",
                border:
                  "1px solid #e8edf2",
                borderRadius:
                  7,
              }}
            >
              <Form.Checkbox
                label="Responsable financiero"
                checked={
                  checked
                }
                onChange={(
                  e,
                  {
                    checked,
                  }
                ) =>
                  setChecked(
                    checked
                  )
                }
                style={{
                  marginBottom:
                    checked
                      ? 16
                      : 0,
                }}
              />

              {checked && (
                <>
                  <div
                    style={{
                      fontSize:
                        12,
                      color:
                        "#697586",
                      marginBottom:
                        12,
                    }}
                  >
                    Datos del responsable financiero asociado al paciente.
                  </div>

                  <Form.Group
                    widths="equal"
                  >
                    <Form.Input
                      fluid
                      label="Nombre Responsable"
                      icon="user"
                      iconPosition="left"
                      placeholder="Nombre"
                      value={
                        nomRsf
                      }
                      onChange={(e) =>
                        setNomRsf(
                          e.target.value
                        )
                      }
                    />

                    <Form.Input
                      fluid
                      label="Dirección Responsable"
                      icon="map marker alternate"
                      iconPosition="left"
                      placeholder="Dirección"
                      value={
                        dirRsf
                      }
                      onChange={(e) =>
                        setDirRsf(
                          e.target.value
                        )
                      }
                    />

                    <Form.Input
                      fluid
                      label="Teléfono Responsable"
                      icon="phone"
                      iconPosition="left"
                      placeholder="Teléfono"
                      value={
                        telRsf
                      }
                      onChange={(e) =>
                        setTelRsf(
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </>
              )}
            </div>

            {/* ============================================== */}
            {/* BOTONES */}
            {/* ============================================== */}

            <div
              style={{
                display:
                  "flex",
                justifyContent:
                  "flex-end",
                alignItems:
                  "center",
                gap:
                  10,
                marginTop:
                  28,
                paddingTop:
                  18,
                borderTop:
                  "1px solid #edf0f4",
                flexWrap:
                  "wrap",
              }}
            >
              <Button
                type="button"
                onClick={
                  volver
                }
                disabled={
                  isSaving
                }
                style={{
                  minWidth:
                    110,
                  background:
                    "#ffffff",
                  color:
                    "#526273",
                  border:
                    "1px solid #d7dee7",
                  borderRadius:
                    6,
                  boxShadow:
                    "none",
                }}
              >
                <Icon
                  name="arrow left"
                />

                Volver
              </Button>

              <Button
                type="submit"
                loading={
                  isSaving
                }
                disabled={
                  isSaving
                }
                style={{
                  minWidth:
                    130,
                  background:
                    "#0d9da5",
                  color:
                    "#ffffff",
                  border:
                    "1px solid #0d9da5",
                  borderRadius:
                    6,
                  boxShadow:
                    "none",
                }}
              >
                {!isSaving && (
                  <Icon
                    name="save"
                  />
                )}

                Actualizar
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ==================================================== */}
      {/* ALERTA */}
      {/* ==================================================== */}

      <Alerta
        tipo={
          alerta.tipo
        }
        mensaje={
          alerta.mensaje
        }
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

// ============================================================
// ESTILOS
// ============================================================

const sectionTitleStyle = {
  color:
    "#344563",
  fontSize:
    12,
  fontWeight:
    700,
  marginBottom:
    10,
  marginTop:
    6,
  textTransform:
    "uppercase",
  letterSpacing:
    "0.3px",
};

export default ActualizaCliente;